import type { RefObject } from 'react'
import { Header } from '@/widgets/header'
import { OnboardingChecklist } from '@/widgets/onboarding-checklist'
import { OnboardingPreview } from '@/widgets/onboarding-preview'
import { ContentGroup } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'

const titleMobileTypography = designTokens.typography.onboarding.titleMobile
const subtitleTypography = designTokens.typography.body.base

const titleMobileStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.primary,
  ...typographyStyle(titleMobileTypography),
}

const subtitleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.strong,
  ...typographyStyle(subtitleTypography),
}

type OnboardingOldPageMobileProps = {
  panelRef: RefObject<HTMLDivElement | null>
  floatingCtaHeight: number | null
  shouldFlattenPanel: boolean
}

export function OnboardingOldPageMobile({
  panelRef,
  floatingCtaHeight,
  shouldFlattenPanel,
}: OnboardingOldPageMobileProps) {
  return (
    <div className="flex w-full flex-col items-center lg:hidden">
      <Header
        className="flex"
        paddingTop={designTokens.components.onboarding.mobile.headerOffset}
      />
      <div
        ref={panelRef}
        className="w-full"
        style={{
          marginBottom: floatingCtaHeight
            ? `${floatingCtaHeight}px`
            : designTokens.spacing.popupModalMobileBottomOffset,
        }}
      >
        <ContentGroup
          variant="planSelectorMobile"
          radius={shouldFlattenPanel ? 'xl-top' : 'xl'}
          className="w-full"
        >
          <div
            className="flex w-full flex-col items-center text-center"
            style={{ gap: designTokens.spacing.xs }}
          >
            <h1 style={titleMobileStyle}>Добро пожаловать!</h1>
            <div style={subtitleStyle}>
              <p style={{ margin: 0 }}>ДД.ММ.ГГГГ подписка будет продлена за Х ₽</p>
              <p style={{ margin: 0 }}>
                Мы напомним о списании за N дней, отправив письмо на ваш email.
              </p>
            </div>
          </div>
          <OnboardingChecklist
            style={{
              width: '100%',
              height: designTokens.components.onboarding.mobile.panelHeight,
            }}
          />
          <OnboardingPreview
            imageFit="cover"
            style={{
              width: '100%',
              height: designTokens.components.onboarding.mobile.panelHeight,
            }}
          />
        </ContentGroup>
      </div>
    </div>
  )
}
